import axios, * as others from "axios";

export const apiURL = process.env.REACT_APP_API_URL; //Livetesting with topindiaelevator.in

export const apiAngularURLProposal = `${process.env.REACT_APP_API_ANGULAR_URL_PROPOSAL}?SessionUserID=${localStorage.getItem(
  "vac_userid",
)}&`; //tiepl Live Topindiaelevator.in AWS

// const axios = require("axios");
const axiosInstance = axios.create({
  baseURL: apiURL,
});

export const loginPath = "./";

export function fetchLogin(data) {
  return axiosInstance.post("Login", data);
}

export function fetchUserManagement(data) {
  return axiosInstance.post("UserManagement", data);
}

export function fetchProposal(data) {
  return axiosInstance.post("Proposal", data);
}

export function fetchpricecalculation(data) {
  return axiosInstance.post("PriceCalculation", data);
}

export function fetchrailprice(data) {
  return axiosInstance.post("railprice", data);
}

export function fetchgeneralitemprice(data) {
  return axiosInstance.post("generalitemprice", data);
}

export function fetchcombinationbracketprice(data) {
  return axiosInstance.post("combinationbracketprice", data);
}

export function fetchcarinside(data) {
  return axiosInstance.post("carinside", data);
}

export function fetchrawmaterialandprocess(data) {
  return axiosInstance.post("rawmaterialandprocess", data);
}

export function fetchRailSelection(data) {
  return axiosInstance.post("RailSelection", data);
}

export function fetchPriceOfBracket(data) {
  return axiosInstance.post("PriceOfBracket", data);
}

export function fetchManualDoorFramePrice(data) {
  return axiosInstance.post("manualdoorframeprice", data);
}

export function fetchAutoDoorMainPrice(data) {
  return axiosInstance.post("autodoormainprice", data);
}

export function fetchMachinePrice(data) {
  return axiosInstance.post("machineprice", data);
}

export function fetchManualDoorPrice(data) {
  return axiosInstance.post("manualdoorprice", data);
}

export function fetchDoorBrand(data) {
  return axiosInstance.post("doorbrand", data);
}
export function fetchDrivePrice(data) {
  return axiosInstance.post("drivePricing", data);
}
export function fetchDriveName(data) {
  return axiosInstance.post("drivename", data);
}

export function fetchDoorMaterialGrade(data) {
  return axiosInstance.post("doormaterialgrade", data);
}

export function fetchPassengerCabin(data) {
  return axiosInstance.post("passengercabin", data);
}

export function fetchGoodsCabin(data) {
  return axiosInstance.post("goodscabin", data);
}

export function fetchArdPrice(data) {
  return axiosInstance.post("ARDprice", data);
}

export function fetchRopePrice(data) {
  return axiosInstance.post("ropeprice", data);
}

export function fetchComChainPrice(data) {
  return axiosInstance.post("comchainprice", data);
}

export function fetchPulleyPrice(data) {
  return axiosInstance.post("pulleyprice", data);
}

export function fetchPulleyDiameterSelection(data) {
  return axiosInstance.post("pulleydiameterselection", data);
}

export function fetchCopPrice(data) {
  return axiosInstance.post("copprice", data);
}

export function fetchLopPrice(data) {
  return axiosInstance.post("lopprice", data);
}

export function fetchCarAndCwFrame(data) {
  return axiosInstance.post("carandcwframe", data);
}

export function fetchCounterWeightKg(data) {
  return axiosInstance.post("counterweightkg", data);
}

export function fetchDashboard(data) {
  return axiosInstance.post("Dashboard", data);
}

export function fetchImportExcel(data) {
  return axiosInstance.post("ImportExport", data);
}

export function fetchClient(data) {
  return axiosInstance.post("ClientMaster", data);
}

export function fetchUsageOfLift(data) {
  return axiosInstance.post("usageoflift", data);
}

export function fetchContractType(data) {
  return axiosInstance.post("contracttype", data);
}

export function fetchService(data) {
  return axiosInstance.post("service", data);
}

export function fetchPaymentCycle(data) {
  return axiosInstance.post("paymentcycle", data);
}

export function fetchPaymentMode(data) {
  return axiosInstance.post("paymentmode", data);
}

export function fetchRaiseOfLift(data) {
  return axiosInstance.post("raiseoflift", data);
}

export function fetchApproachabilityToSite(data) {
  return axiosInstance.post("approachabilitytosite", data);
}

export function fetchServiceAndCallback(data) {
  return axiosInstance.post("serviceandcallback", data);
}

export function fetchCustomerCategory(data) {
  return axiosInstance.post("customercategory", data);
}

export function fetchBlockedBy(data) {
  return axiosInstance.post("blockedby", data);
}

export function fetchPaymentStatus(data) {
  return axiosInstance.post("paymentstatus", data);
}

export function fetchLostReason(data) {
  return axiosInstance.post("lostreason", data);
}

export function fetchMailMaster(data) {
  return axiosInstance.post("mailmaster", data);
}

export function fetchServiceLocation(data) {
  return axiosInstance.post("servicelocation", data);
}

export function fetchBilling(data) {
  return axiosInstance.post("BillingMaster", data);
}

export function fetchSite(data) {
  return axiosInstance.post("SiteMaster", data);
}

export function fetchReciept(data) {
  return axiosInstance.post("Reciept", data);
}

export function fetchGSTInfo(data) {
  return axiosInstance.post("GSTInfo", data);
}

export function fetchLedgeGroup(data) {
  return axiosInstance.post("LedgerGroup", data);
}
